// Helpers for reconciling the React UI with the PHP backend's data shapes.

// Player ids come back as numbers from MySQL but as strings from form params,
// so compare loosely by string.
export const sameId = (a, b) =>
  a !== null && a !== undefined && b !== null && b !== undefined &&
  String(a) === String(b);

// A player's `cards` column is stored as a JSON string (or empty).
export const parseCards = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    return JSON.parse(raw) || [];
  } catch (e) {
    return [];
  }
};

export const hasPlayed = (player) =>
  Boolean(player && player.current_card_1 && player.current_card_1 !== '');

// Card text from the CAH dataset contains HTML (e.g. <br>, <i>) that the
// original frontend rendered as markup. Content is from the fixed deck (and the
// backend htmlspecialchars-encodes played cards), so this is not user input.
export const cardMarkup = (text) => ({ __html: text || '' });
